import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';
import logo from '../../../images/logo no bg-03.png';
import './home.css';
import visaCardLogo from '../../../icons/cards/visa.png';
import masterCardLogo from '../../../icons/cards/master card.png';

const COLUMNS = [
  {
    title: 'Products',
    links: [
      { label: 'Tasks', to: '/products/task' },
      { label: 'Snap Bill', to: '/products/snap-bill' },
      { label: 'Documents', to: '/products/documents' },
      { label: 'Projects', to: '/products/projects' },
      { label: 'Credentials Vault', to: '/products/credentials-vault' },
      { label: 'Discussions Forum', to: '/products/discussion-forum' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', to: '/about-us' },
      { label: 'Contact', to: '/contact-us' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Help', to: '/contact-us' },
      { label: 'Pricing', to: '/pricing' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', to: '/privacy-policy' },
      { label: 'Terms', to: '/terms-and-conditions' },
      { label: 'Refund', to: '/refund-cancellation-policy' },
    ],
  },
];

const HomeFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="home-footer">
      <div className="home-container">
        <div className="home-footer-brandrow">
          <div className="home-footer-brand">
            <img src={logo} alt="flowdo" className="home-footer-logo" />
          </div>
        </div>

        <div className="home-footer-cols">
          {COLUMNS.map((column) => (
            <div key={column.title}>
              <h3>{column.title}</h3>
              {column.links.map((link) => (
                <Link key={link.label} to={link.to}>
                  {link.label}
                  <FiChevronRight />
                </Link>
              ))}
            </div>
          ))}
        </div>

        <div className="home-footer-bottom">
          <p>© {year} flowdo. All rights reserved.</p>
          <div className="home-footer-payments" role="img" aria-label="We accept Visa and Mastercard">
            <img src={visaCardLogo} alt="" />
            <img src={masterCardLogo} alt="" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default HomeFooter;
